import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "time-edit-view" }
const _hoisted_2 = { class: "row v-center gap" }
const _hoisted_3 = { class: "items row col" }
const _hoisted_4 = { class: "h1" }
const _hoisted_5 = {
  key: 0,
  class: "h4 gray"
}
const _hoisted_6 = {
  key: 1,
  class: "h4 gray"
}
const _hoisted_7 = {
  key: 2,
  class: "h4 gray"
}
const _hoisted_8 = { class: "scroll row col gap" }
const _hoisted_9 = {
  key: 0,
  class: "loading-box"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "times"
}
const _hoisted_12 = { class: "row v-center" }
const _hoisted_13 = { class: "row col sm-gap" }
const _hoisted_14 = { class: "bold row v-center" }
const _hoisted_15 = {
  key: 0,
  class: "box"
}
const _hoisted_16 = { class: "price" }
const _hoisted_17 = {
  key: 0,
  class: "wide"
}
const _hoisted_18 = {
  key: 1,
  class: "small"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "row spaced" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_section = _resolveComponent("date-section")!
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_si_currency = _resolveComponent("si-currency")!
  const _component_progress_button = _resolveComponent("progress-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'OrderTime' })))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "gg-close" }, null, -1)
      ])),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "fill row center h2" }, "Edit booking", -1))
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("small", null, "You are editing", -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.activity?.name), 1),
      (_ctx.activityDateString)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.activityDateString), 1))
        : _createCommentVNode("", true),
      (!!_ctx.time?.Rates.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.rates), 1))
        : _createCommentVNode("", true),
      (_ctx.addons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.addons), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_date_section),
      (_ctx.loading || _ctx.getTimesLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_loader_display)
          ]))
        : (_ctx.time?.AppointmentTypeKey == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.activity?.availableTimes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity?.availableTimes, (time) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: time.DisplayName ?? -1,
                        class: _normalizeClass(["row spaced gap v-center time", { selected: _ctx.selected(time) }])
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createTextVNode(_toDisplayString(time.DisplayName) + " ", 1),
                              (time.Description)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(time.Description), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["time-details", _ctx.priceClass(time)])
                            }, [
                              _cache[9] || (_cache[9] = _createTextVNode(" Subtotal: ", -1)),
                              _createVNode(_component_si_currency, {
                                amount: time.SubTotal,
                                class: "pad-right"
                              }, null, 8, ["amount"]),
                              _createElementVNode("div", _hoisted_16, [
                                _cache[6] || (_cache[6] = _createTextVNode(" (", -1)),
                                _createVNode(_component_si_currency, {
                                  amount: _ctx.priceDifference(time)
                                }, null, 8, ["amount"]),
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon" }, [
                                  _createElementVNode("div", { class: "gg-arrow-up" }),
                                  _createElementVNode("div", { class: "gg-arrow-down" })
                                ], -1)),
                                _cache[8] || (_cache[8] = _createTextVNode(" ) ", -1))
                              ]),
                              _createTextVNode(" • " + _toDisplayString(time.TotalAvailable) + " spot" + _toDisplayString(time.TotalAvailable == 1 ? '' : 's') + " available ", 1)
                            ], 2)
                          ])
                        ]),
                        (_ctx.selected(time))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[10] || (_cache[10] = [
                              _createElementVNode("div", { class: "gg-check" }, null, -1)
                            ])))
                          : (time?.CallToBook)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _cache[11] || (_cache[11] = _createTextVNode(" To book this time, please call us at ", -1)),
                                _createElementVNode("a", {
                                  href: `tel:${_ctx.phoneNumber}`
                                }, _toDisplayString(_ctx.phoneNumber), 9, _hoisted_19)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("button", {
                                  class: "blue",
                                  onClick: ($event: any) => (_ctx.book(time))
                                }, "Book", 8, _hoisted_21)
                              ]))
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, "No times available"))
            ]))
          : (!_ctx.activity?.availableTimes.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[12] || (_cache[12] = [
                _createElementVNode("div", { class: "gray row center v-center sm-gap" }, [
                  _createElementVNode("div", { class: "gg-info" }),
                  _createTextVNode(" This date has no availability, please select another ")
                ], -1)
              ])))
            : _createCommentVNode("", true)
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", {
        class: "row v-center gray",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
      }, _cache[13] || (_cache[13] = [
        _createElementVNode("span", { class: "gg-chevron-left" }, null, -1),
        _createTextVNode(" Back", -1)
      ])),
      (_ctx.time?.AppointmentTypeKey == 2)
        ? (_openBlock(), _createBlock(_component_progress_button, {
            key: 0,
            onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTime())),
            disabled: !_ctx.canSubmit
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode(" Continue ", -1)
            ])),
            _: 1,
            __: [14]
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}